module.exports = __webpack_public_path__ + "static/img/R1612P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/R1612P_1.png
// module id = dDTC
// module chunks = 0